import React from 'react';
import SearchMap from './SearchMap';

const SearchMapSplitter = (props) => {
    const { ...mapProps } = props;

    const MapToShow = SearchMap;

    return <MapToShow {...mapProps} />;
};

export default SearchMapSplitter;
